<section class="business-registration-ads-online-by-yourself">
  <div class="box">
    <div class="left">
      <div class="img-wrapper" (click)="linkVideo('6SoO6iSY2Po')">
        <picture>
          <source
            srcset="https://flowaccountcdn.com/new_landing/image/business-registration/dbd_e-registration_v2.webp"
            type="image/webp"
          />
          <img
            src="https://flowaccountcdn.com/new_landing/image/business-registration/dbd_e-registration_v2.jpg"
            class="img-cover"
            [alt]="'BUSINESS_REGISTRATION_ADS.ONLINE_BY_YOURSELF.TITLE' | translate"
            loading="lazy"
          />
        </picture>

        <div class="icon-wrapper">
          <picture>
            <source
              srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
              type="image/webp"
            />
            <img
              src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
              class="icon-play"
              [alt]="'BUSINESS_REGISTRATION_ADS.ONLINE_BY_YOURSELF.TITLE' | translate"
              loading="lazy"
            />
          </picture>
        </div>
      </div>
    </div>

    <div class="right">
      <h2 class="title" [innerHtml]="'BUSINESS_REGISTRATION_ADS.ONLINE_BY_YOURSELF.TITLE' | translate"></h2>
      <div class="description" [innerHtml]="'BUSINESS_REGISTRATION_ADS.ONLINE_BY_YOURSELF.DETAIL' | translate"> </div>
      <div class="btn-wrapper">
        <button class="btn-video" (click)="linkVideo('M8XUxtRbSa8')">
          <i class="far fa-play-circle"></i>
          <span class="text">{{ 'BUSINESS_REGISTRATION_ADS.ONLINE_BY_YOURSELF.BTN' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</section>
